import React, { useState } from "react"

const SaasFaq: React.FC = () => {

    // Accordion Active Index
    const [active, setActive] = useState<number>(1);

    const toggleAccordion = (index: number) => {
        setActive(active === index ? -1 : index);
    };

    const faqItems = [
        {
            id: 1,
            title: "01. Connect And Upload",
            content:
                "Easily connect your tools or upload your data. Our platform integrates seamlessly with your existing workflows, so you can get started in minutes.",
        },
        {
            id: 2,
            title: "02. AI Analysis",
            content:
                "Our advanced AI analyzes your data or tasks in real time, uncovering insights, patterns, and opportunities tailored to your needs.",
        },
        {
            id: 3,
            title: "03. Actionable Results",
            content:
                "Receive instant, actionable outputs — from AI-generated content and recommendations to reports and predictions — designed to help you make smarter decisions.",
        },
        {
            id: 4,
            title: "04. Automate And Optimize",
            content:
                "Turn insights into action. Automate tasks, optimize processes, and continuously improve results with AI-driven strategies.",
        },
    ];


    return (
            <div className="service-process-wrap pt-120 pb-125">
                <div className="row mt-none-50 align-items-center">
                    {/* LEFT SIDE ACCORDION */}
                    <div className="col-lg-6 mt-50">
                        <h2 className="details-content-title mb-40">How It Works</h2>

                        <div className="service_process_faq">
                            <div className="accordion">
                                {faqItems.map((item) => (
                                    <div className="accordion-item" key={item.id}>
                                        <div
                                            className={`accordion-button ${active === item.id ? "" : "collapsed"
                                                }`}
                                            role="button"
                                            onClick={() => toggleAccordion(item.id)}
                                        >
                                            {item.title}
                                        </div>

                                        <div
                                            className={`accordion-collapse collapse ${active === item.id ? "show" : ""
                                                }`}
                                        >
                                            <div className="accordion-body">
                                                <p className="m-0">{item.content}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* RIGHT SIDE CLICKABLE LIST */}
                    <div className="col-lg-6 mt-50">
                        <ul className="content_layer_group list-unstyled">
                            {faqItems.map((item) => (
                                <li
                                    key={item.id}
                                    onClick={() => toggleAccordion(item.id)}
                                    className={active === item.id ? "active" : ""}
                                >
                                    <span>{item.title.replace(/^\d+\.\s/, "")}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
    )
}

export default SaasFaq;